import { useEffect } from "react";
import deleteAccountMd from "../content/policies/delete-account.md?raw";
import { renderMarkdown } from "../lib/markdown";
import { EditorialPage } from "../components/editorial";
import Navbar from "../components/Navbar";
import StoryPageHero from "../components/story/StoryPageHero";

// Google Play requires a publicly reachable URL explaining how to delete your
// account and data WITHOUT installing the app, so this page has to stand on its
// own for a reader who has never opened LetsLoop.
//
// Structure deliberately mirrors PrivacyPage: header band from StoryPageHero,
// body left plain. These pages get read under pressure by someone who wants out,
// and decorating running policy text makes it harder to follow, not better.

export default function DeleteAccountPage() {
  useEffect(() => {
    document.title = "Delete Your Account | LetsLoop";
  }, []);

  return (
    <>
      <Navbar />
      <EditorialPage>
        <StoryPageHero
          kicker="delete account"
          title={<>Leaving? Here is exactly what happens.</>}
          marks={[
            {
              name: "loop",
              size: 58,
              rotate: -6,
              className: "right-[8%] top-[30%] text-teal/25",
            },
          ]}
        />

        <article className="relative max-w-3xl mx-auto px-4 md:px-6 pt-4 pb-16 md:pb-24">
          {renderMarkdown(deleteAccountMd)}
        </article>
      </EditorialPage>
    </>
  );
}
